// Chakra imports
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "../../../../components/admindashboard/card/Card";
import PieChart from "../../../../components/admindashboard/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import { VSeparator } from "../../../../components/admindashboard/separator/Separator";
import React from "react";

export default function Conversion(props) {
  const {
    title = "Your Pie Chart",
    chartData = pieChartData,
    chartOptions = pieChartOptions,
    legendItems = [
      { label: "Your files", value: "63%", color: "brand.500" },
      { label: "System", value: "25%", color: "#6AD2FF" },
    ],
    ...rest
  } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card p='20px' align='center' direction='column' w='100%' {...rest}>
      <Flex
        px={{ base: "0px", "2xl": "10px" }}
        justifyContent='flex-start'
        alignItems='center'
        w='100%'
        mb='8px'>
        <Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
          {title}
        </Text>
      </Flex>

      <PieChart
        h='100%'
        w='100%'
        chartData={chartData}
        chartOptions={chartOptions}
      />
      <Card
        bg={cardColor}
        flexDirection='row'
        flexWrap='wrap'
        gap='12px'
        boxShadow={cardShadow}
        w='100%'
        p='15px'
        px='20px'
        mt='15px'
        mx='auto'>
        {legendItems.map((item, index) => (
          <React.Fragment key={item.label}>
            {index > 0 ? <VSeparator mx={{ base: "20px", xl: "20px", "2xl": "20px" }} /> : null}
            <Flex direction='column' py='5px' me='10px'>
              <Flex align='center'>
                <Box h='8px' w='8px' bg={item.color} borderRadius='50%' me='4px' />
                <Text
                  fontSize='xs'
                  color='secondaryGray.600'
                  fontWeight='700'
                  mb='5px'>
                  {item.label}
                </Text>
              </Flex>
              <Text fontSize='lg' color={textColor} fontWeight='700'>
                {item.value}
              </Text>
            </Flex>
          </React.Fragment>
        ))}
      </Card>
    </Card>
  );
}
